export const mergeAndDeduplicate = arr => [...new Set([].concat(...arr))]

export const getIntersection = (a1, a2) => a1.filter(n => a2.indexOf(n) !== -1)
